/**
 * Build a fully-resolved CornerstonePage config from localized data.
 *
 * Takes the JSON-style data (icons as strings, recommend as nested results)
 * from cornerstones/{lang}.js and resolves:
 *   - icon strings → lucide-react components
 *   - recommend results → recommend(ratio) function
 *   - comparison rows already include label+values together
 *
 * Booleans / numbers (option scores, comparison values) pass through unchanged.
 */
import { resolveIcon } from "@/data/cornerstones/iconMap";

const mapIconList = (list = []) =>
  list.map((item) => ({ ...item, icon: resolveIcon(item.icon) }));

export function buildCornerstoneConfig(path, data) {
  if (!data) return null;
  const results = data.helper?.results || {};
  const recommend = (ratio) => {
    if (ratio < 0.35) return results.low;
    if (ratio < 0.7) return results.mid;
    return results.high;
  };

  return {
    path,
    seo: data.seo,
    hero: {
      ...data.hero,
      pills: mapIconList(data.hero.pills),
    },
    pains: data.pains,
    what: {
      ...data.what,
      targetGroups: mapIconList(data.what.targetGroups),
    },
    criteria: {
      ...data.criteria,
      items: mapIconList(data.criteria.items),
    },
    comparison: data.comparison,
    why: {
      ...data.why,
      points: mapIconList(data.why.points),
    },
    nicheA: data.nicheA,
    nicheB: data.nicheB,
    beforeAfter: data.beforeAfter,
    helper: {
      title: data.helper.title,
      lead: data.helper.lead,
      questions: data.helper.questions,
      recommend,
    },
    faqTitle: data.faqTitle,
    faq: data.faq,
  };
}

export default buildCornerstoneConfig;
